import React from 'react';
import { ReactComponent as WorkIcon } from "../../TimelineIcons/TimelineBilder/work.svg.svg";
import { ReactComponent as SchoolIcon } from "../../TimelineIcons/TimelineBilder/school.svg.svg";
import {timelineElements} from "../../data/ChronikData";
import "./Chronic.css";

import {VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component"

import "react-vertical-timeline-component/style.min.css"

function Chronic(){
    let workIconStyles = {background: "#000B5B", borderColor: "black"};
    let schoolIconStyles = {background: "#33385C"};

    return(
        <div className="ChronicBody" style={{background: "white", fontFamily: "Montserrat, sans-serif" , }}>
            <div className="header" style={{padding:"60px 0", display:"flex", flexDirection:"column", justifyContent:"center", background:"#940000"}}/>
            <h1 className="title" style={{fontSize: "7em", textAlign:"center", fontFamily: "Bebas Neue, sans-serif", color: "black", padding:"0.6em"}}>Chronik</h1>
            <VerticalTimeline lineColor={ "black"} >
                {
                    timelineElements.map(element => {

                        let isWorkIcon = element.icon === "work";
                        let showButton = element.buttonText !== undefined && element.buttonText !== null && element.buttonText !== "";

                        return(
                            <VerticalTimelineElement
                            key={element.key}
                            date={element.date }
                            dateClassName= "date"
                            iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
                            icon={ isWorkIcon ? <WorkIcon /> : <SchoolIcon />}
                            >
                                <h3 className="vertical-timeline-element-title" style={{paddingTop:"0.15em"}}>{element.title}</h3>
                                <h5 className= "vertical-timeline-element-subtitle">{element.location}</h5>
                                <p id="description">{element.description}</p>
                                {showButton && (
                                    <a
                                        className={`button ${
                                            isWorkIcon ? "workButton" : "schoolButton"
                                        }
`}
                                        href="/"
                                    >
                                        {element.buttonText}
                                    </a>
                                )}
                            </VerticalTimelineElement>
                        )
                    })
                }
            </VerticalTimeline>
        </div>


    );
};
export default Chronic;